import DownloadTermsSection from "./DownloadTermsSection";

export default DownloadTermsSection